/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: frLTK57AGre4oWC8c14hh8

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsyWjaUeicFc8X } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: yWjaUeicFc8x/globalVariant
import { TmpValue, useTmp } from "./PlasmicGlobalVariant__Tmp"; // plasmic-import: 5L_h0So0pKw4/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsyWjaUeicFc8X,
  tmp: useTmp
});
